import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import { CreateParams, DataProvider } from "@refinedev/core";
import axAPI from "../../../api/axios-instance";

export type AppIconSettings = {
  defaultIcon: string;
  clubIconsEnabled: boolean;
  availableIcons: string[];
};

export type AppIconSettingsUpdate = Pick<
  AppIconSettings,
  "defaultIcon" | "clubIconsEnabled"
>;

/** Иконка приложения (9574): одна ручка на чтение и запись. */
export const appIconDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    custom: async ({ url }) => {
      try {
        if (url === "settings") {
          const { data } = await httpClient.get<AppIconSettings>(
            "/cms/app/icon"
          );
          return { data };
        }

        return Promise.reject(new Error("Неизвестный запрос"));
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables }: CreateParams<AppIconSettingsUpdate>) => {
      try {
        const { data } = await httpClient.post("/cms/app/icon", variables);
        return { data };
      } catch (error: unknown) {
        return Promise.reject(error);
      }
    },
  };
